import {useContext, useMemo} from 'react';

import {ErrorMessage} from 'formik';
import {useTranslation} from 'react-i18next';

import {Grid, Typography} from '@mui/material';

import {MultiSelectV2} from '../../../../../../../../../components/MultiSelectV2/MultiSelectV2';
import {LanguageContext} from '../../../../../../../../../contexts/LanguageContext/LanguageContext';
import {Option} from '../../../../../../../../../types/shared-types';
import {safelyUseLanguageProfile} from '../../../../../../../../../utils/safelyUseLanguageProfile';
import {SubDepartment} from '../../../../../types/JobPostingsTypes';

interface Props {
  options: SubDepartment[];
  formik: any;
}

export const HardFactsFieldsSubdepartment = ({options, formik}: Props) => {
  const {t} = useTranslation();
  const currentLanguage = useContext(LanguageContext);
  const onChange = (values: Option[]) => {
    formik.setFieldValue(
      'subdepartments',
      values.map((opt) => opt.id)
    );
  };

  const subdepartmentOptions = useMemo(
    () =>
      options.map((option) => {
        return {
          id: option.resourceId,
          label: safelyUseLanguageProfile(currentLanguage, option.name) || '',
          selected: (formik.values.subdepartments || []).some((id: string) => id === option.resourceId),
        };
      }),
    [options, currentLanguage, formik.values.subdepartments]
  );

  return (
    <Grid item xs={12}>
      <MultiSelectV2
        label={`${t('companyJobPostings.newJobDialog.formLabels.subdepartment')}`}
        options={subdepartmentOptions}
        onChangeHandler={onChange}
        size='small'
      />
      <Typography variant='body2' color='error'>
        <ErrorMessage name='subdepartments' component='span' />
      </Typography>
    </Grid>
  );
};
